// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home_homeBody__cGV6T {
  display: flex;
  width: 100%;
  gap: 30px;
  position: relative;
  overflow-y: hidden !important;
}
.home_homeBody__cGV6T .home_headerText__mPKxA {
  font-family: Poppins;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  text-align: left;
  margin-bottom: 12px;
}
.home_homeBody__cGV6T .home_left__wGbLK {
  width: 70%;
  display: flex;
  flex-direction: column;
  gap: 80px;
  overflow-y: scroll !important;
}
.home_homeBody__cGV6T .home_left__wGbLK .home_box__ibrd8 .home_flex_div__yXTNi {
  display: flex;
  justify-content: space-between;
}
.home_homeBody__cGV6T .home_left__wGbLK .home_box__ibrd8 .home_secondCard__oZEkf .home_card__xxKkV,
.home_homeBody__cGV6T .home_left__wGbLK .home_box__ibrd8 .home_MyPayments__Shn3F .home_card__xxKkV {
  width: 48%;
  border-radius: 20px;
  background-color: black;
  gap: 24px;
  padding: 30px 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}
.home_homeBody__cGV6T .home_left__wGbLK .home_box__ibrd8 .home_secondCard__oZEkf .home_card__xxKkV .home_icon__GtBCf,
.home_homeBody__cGV6T .home_left__wGbLK .home_box__ibrd8 .home_MyPayments__Shn3F .home_card__xxKkV .home_icon__GtBCf {
  width: 40.58px;
  height: 37.5px;
}
.home_homeBody__cGV6T .home_left__wGbLK .home_box__ibrd8 .home_secondCard__oZEkf .home_card__xxKkV .home_text__RyGYn,
.home_homeBody__cGV6T .home_left__wGbLK .home_box__ibrd8 .home_MyPayments__Shn3F .home_card__xxKkV .home_text__RyGYn {
  font-family: Inter;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  text-align: left;
  color: white;
}
.home_homeBody__cGV6T .home_left__wGbLK .home_box__ibrd8 .home_secondCard__oZEkf .home_cardOne__uissf,
.home_homeBody__cGV6T .home_left__wGbLK .home_box__ibrd8 .home_MyPayments__Shn3F .home_cardOne__uissf {
  background: linear-gradient(298.54deg, #074294 0%, #529CE4 100%);
}
.home_homeBody__cGV6T .home_left__wGbLK .home_box__ibrd8 .home_secondCard__oZEkf .home_cardTwo__W-AV2,
.home_homeBody__cGV6T .home_left__wGbLK .home_box__ibrd8 .home_MyPayments__Shn3F .home_cardTwo__W-AV2 {
  background: linear-gradient(97.95deg, #2D4F70 2.2%, #05213D 99.33%);
}
.home_homeBody__cGV6T .home_left__wGbLK .home_box__ibrd8 .home_secondCard__oZEkf .home_payVendor__bu3bU,
.home_homeBody__cGV6T .home_left__wGbLK .home_box__ibrd8 .home_MyPayments__Shn3F .home_payVendor__bu3bU {
  background: linear-gradient(276.1deg, #3082D4 0.31%, #47B7E8 100%);
}
.home_homeBody__cGV6T .home_left__wGbLK .home_box__ibrd8 .home_secondCard__oZEkf .home_viewVedorShop__pL3N7,
.home_homeBody__cGV6T .home_left__wGbLK .home_box__ibrd8 .home_MyPayments__Shn3F .home_viewVedorShop__pL3N7 {
  background: linear-gradient(276.1deg, #3A41C8 0.31%, #935FE5 100%);
}
.home_homeBody__cGV6T .home_left__wGbLK .home_box__ibrd8 .home_bills__F4tyf .home_boxesContainer__71e-I .home_billsbox__px-7K {
  width: 30%;
  padding: 32px;
  border-radius: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgb(230, 232, 240);
  text-align: center;
  gap: 20px;
  flex-direction: column;
}
.home_homeBody__cGV6T .home_left__wGbLK .home_box__ibrd8 .home_bills__F4tyf .home_boxesContainer__71e-I .home_billsbox__px-7K .home_billstext__V2ZJ0 {
  font-family: Inter;
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: 0.1000000015px;
  text-align: center;
  color: rgb(25, 118, 210);
  margin-top: 2px;
}
.home_right__Jo62b {
  width: 100%;
  height: 336px;
  padding: 20px 24px 20px 24px;
  gap: 16px;
  border-radius: 16px;
  background-color: rgb(242, 243, 252);
}
.home_right__Jo62b .home_balances__ZTZD4 {
  width: 100%;
}
.home_right__Jo62b .home_balances__ZTZD4 .home_balancecard__X143P {
  width: 100%;
  padding: 16px;
  margin: 16px 0;
  gap: 8px;
  border-radius: 12px;
  background-color: rgb(255, 255, 255);
}
.home_right__Jo62b .home_balances__ZTZD4 .home_balancecard__X143P img {
  width: 20px;
  height: 20px;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Home/styles/home.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;EACA,6BAAA;AACJ;AACI;EAEI,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AAAR;AAGI;EACI,UAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,6BAAA;AADR;AAKY;EACI,aAAA;EACA,8BAAA;AAHhB;AAWgB;;EACI,UAAA;EACA,mBAAA;EACA,uBAAA;EAEA,SAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;AATpB;AAWoB;;EACI,cAAA;EACA,cAAA;AARxB;AAWoB;;EAEI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AATxB;AAagB;;EACI,gEAAA;AAVpB;AAagB;;EACI,mEAAA;AAVpB;AAagB;;EACI,kEAAA;AAVpB;AAagB;;EACI,kEAAA;AAVpB;AAkBoB;EACI,UAAA;EAEA,aAAA;EAEA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,kBAAA;EACA,SAAA;EACA,sBAAA;AAjBxB;AAmBwB;EAEI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,8BAAA;EACA,kBAAA;EACA,wBAAA;EACA,eAAA;AAlB5B;AA+BA;EACI,WAAA;EACA,aAAA;EACA,4BAAA;EACA,SAAA;EACA,mBAAA;EACA,oCAAA;AA7BJ;AA+BI;EACI,WAAA;AA7BR;AA8BQ;EACI,WAAA;EAEA,aAAA;EACA,cAAA;EACA,QAAA;EACA,mBAAA;EACA,oCAAA;AA7BZ;AA8BY;EACI,WAAA;EACA,YAAA;AA5BhB","sourcesContent":[".homeBody {\n    display: flex;\n    width: 100%;\n    gap: 30px;\n    position: relative;\n    overflow-y: hidden !important;\n\n    .headerText {\n        //styleName: Labels/Medium;\n        font-family: Poppins;\n        font-size: 16px;\n        font-weight: 600;\n        line-height: 24px;\n        text-align: left;\n        margin-bottom: 12px;\n    }\n\n    .left {\n        width: 70%;\n        display: flex;\n        flex-direction: column;\n        gap: 80px;\n        overflow-y: scroll !important;\n\n        .box {\n\n            .flex_div {\n                display: flex;\n                justify-content: space-between;\n            }\n\n\n\n            .secondCard,\n            .MyPayments {\n\n                .card {\n                    width: 48%;\n                    border-radius: 20px;\n                    background-color: black;\n                    // height: 250px;\n                    gap: 24px;\n                    padding: 30px 24px;\n                    display: flex;\n                    flex-direction: column;\n                    justify-content: space-evenly;\n\n                    .icon {\n                        width: 40.58px;\n                        height: 37.5px;\n                    }\n\n                    .text {\n                        //styleName: material-theme/title/medium;\n                        font-family: Inter;\n                        font-size: 24px;\n                        font-weight: 600;\n                        line-height: 32px;\n                        text-align: left;\n                        color: white;\n                    }\n                }\n\n                .cardOne {\n                    background: linear-gradient(298.54deg, #074294 0%, #529CE4 100%);\n                }\n\n                .cardTwo {\n                    background: linear-gradient(97.95deg, #2D4F70 2.2%, #05213D 99.33%);\n                }\n\n                .payVendor {\n                    background: linear-gradient(276.1deg, #3082D4 0.31%, #47B7E8 100%);\n                }\n\n                .viewVedorShop {\n                    background: linear-gradient(276.1deg, #3A41C8 0.31%, #935FE5 100%);\n\n                }\n            }\n\n            .bills {\n                .boxesContainer {\n\n                    .billsbox {\n                        width: 30%;\n                        // height: 192px;\n                        padding: 32px;\n                        gap: 16px;\n                        border-radius: 24px;\n                        display: flex;\n                        align-items: center;\n                        justify-content: center;\n                        background-color: rgba(230, 232, 240, 1);\n                        text-align: center;\n                        gap: 20px;\n                        flex-direction: column;\n\n                        .billstext {\n                            //styleName: material-theme/title/small;\n                            font-family: Inter;\n                            font-size: 20px;\n                            font-weight: 600;\n                            line-height: 28px;\n                            letter-spacing: 0.10000000149011612px;\n                            text-align: center;\n                            color: rgba(25, 118, 210, 1);\n                            margin-top: 2px;\n                        }\n                    }\n                }\n            }\n\n            .MyPayments {\n                .cards {}\n            }\n        }\n\n    }\n}\n.right {\n    width: 100%;\n    height: 336px;\n    padding: 20px 24px 20px 24px;\n    gap: 16px;\n    border-radius: 16px;\n    background-color: rgba(242, 243, 252, 1);\n\n    .balances {\n        width: 100%;\n        .balancecard {\n            width: 100%;\n            // height: 9px;\n            padding: 16px;\n            margin: 16px 0;\n            gap: 8px;\n            border-radius: 12px;\n            background-color: rgba(255, 255, 255, 1);\n            img{\n                width: 20px;\n                height: 20px;\n            }\n        }\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"homeBody": `home_homeBody__cGV6T`,
	"headerText": `home_headerText__mPKxA`,
	"left": `home_left__wGbLK`,
	"box": `home_box__ibrd8`,
	"flex_div": `home_flex_div__yXTNi`,
	"secondCard": `home_secondCard__oZEkf`,
	"card": `home_card__xxKkV`,
	"MyPayments": `home_MyPayments__Shn3F`,
	"icon": `home_icon__GtBCf`,
	"text": `home_text__RyGYn`,
	"cardOne": `home_cardOne__uissf`,
	"cardTwo": `home_cardTwo__W-AV2`,
	"payVendor": `home_payVendor__bu3bU`,
	"viewVedorShop": `home_viewVedorShop__pL3N7`,
	"bills": `home_bills__F4tyf`,
	"boxesContainer": `home_boxesContainer__71e-I`,
	"billsbox": `home_billsbox__px-7K`,
	"billstext": `home_billstext__V2ZJ0`,
	"right": `home_right__Jo62b`,
	"balances": `home_balances__ZTZD4`,
	"balancecard": `home_balancecard__X143P`
};
export default ___CSS_LOADER_EXPORT___;
